import React from 'react';

import styled from '@tanium/react-emotion-9';

import { DEEMPHASIZED_OPACITY, opacityTransition, strokeWidthTransition } from '../../utils/transitions';
import { Path } from '../Path';
import { ShapeProps } from '../XYChart';

const None = () => 'none';

const StyledPath = styled(Path)({
  transition: `${opacityTransition}, ${strokeWidthTransition}`,
});

export const LineShape = ({ color, emphasisLevel, path }: ShapeProps): JSX.Element => {
  return (
    <StyledPath
      d={path}
      fill={None}
      stroke={color}
      strokeWidth={emphasisLevel === 'emphasized' ? 2 : 1}
      opacity={emphasisLevel === 'deemphasized' ? DEEMPHASIZED_OPACITY : undefined}
    />
  );
};
